export default __webpack_public_path__ + "static/media/briefing.cabf2054.svg";